import { Col, DatePicker, Row, Tabs, message, TimePicker } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Select } from "antd";
import { MyEditor } from "../../../components/Editor";
import ImageUploader from "components/shared-components/ImageUploader";
import moment from "moment";
import locale from "antd/es/date-picker/locale/id_ID";
import {
  addActivity,
  updateActivity,
  fetchOneActivity,
} from "redux/features/activity";

const selectStyle = {
  width: "100%",
  backgroundColor: "white",
};

const rules = [
  {
    required: true,
    message: "Wajib Diisi!",
  },
];

const combineDateTime = (date, time) =>
  moment(
    `${moment(date).format("YYYY-MM-DD")} ${moment(time).format("HH:mm")}`
  ).format("YYYY-MM-DDTHH:mm");

const activityTypes = [
  { label: "Kunjungan Kerja (Kunker)", value: "kunker" },
  { label: "Sosialisasi", value: "sosialisasi" },
  { label: "Rapat", value: "rapat" },
  { label: "Workshop / Pelatihan", value: "workshop" },
  { label: "Konsultasi", value: "konsultasi" },
  { label: "Penyuluhan", value: "penyuluhan" },
  { label: "Kegiatan Internal", value: "internal" },
  { label: "Kegiatan Eksternal", value: "eksternal" },
  { label: "Lainnya", value: "lainnya" },
];

export const ADD_ACTIVITY = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);

  const [idBody, setIdBody] = useState("");
  const [enBody, setEnBody] = useState("");
  const [subcategories, setSubcategories] = useState();
  const [tags, setTags] = useState();
  const [imgUrl, setImgUrl] = useState("");
  const isEdit = Boolean(location?.state?.id);

  const onFinish = (values) => {
    if (location?.state?.id) {
      updateData(values);
    } else {
      createData(values);
    }
  };

  const createData = async (values) => {
    try {
      const startDateTime = combineDateTime(
        values.start_date,
        values.start_time
      );
      const endDateTime = combineDateTime(values.end_date, values.end_time);

      await dispatch(
        addActivity({
          ...values,
          user_id: user.id,
          start_date: startDateTime,
          end_date: endDateTime,
        })
      ).unwrap();

      history.push("/app/activity");
    } catch (error) {
      console.log("Error detail:", error);

      if (error?.errors && Array.isArray(error.errors)) {
        error.errors.forEach((e) => message.error(e));
      } else if (error?.message) {
        message.error(error.message);
      } else {
        message.error("Terjadi kesalahan saat memproses data");
      }
    }
  };

  const updateData = async (values) => {
    try {
      const startDateTime = combineDateTime(
        values.start_date,
        values.start_time
      );
      const endDateTime = combineDateTime(values.end_date, values.end_time);

      const payload = {
        ...values,
        id: location?.state?.id,
        start_date: startDateTime,
        end_date: endDateTime,
      };

      console.log("payload to update:", payload);

      await dispatch(updateActivity(payload)).unwrap();
      history.push("/app/activity");
    } catch (error) {
      console.log("Error detail:", error);

      if (error?.errors && Array.isArray(error.errors)) {
        error.errors.forEach((e) => message.error(e));
      } else if (error?.message) {
        message.error(error.message);
      } else {
        message.error("Terjadi kesalahan saat memproses data");
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getDataById = async (id) => {
    try {
      const data = await dispatch(fetchOneActivity(id)).unwrap();
      form.setFieldsValue({
        ...data.data,
        category: data.data.category_id,
        start_date: data.data.start_date ? moment(data.data.start_date) : null,
        start_time: data.data.start_date ? moment(data.data.start_date) : null,
        end_date: data.data.end_date ? moment(data.data.end_date) : null,
        end_time: data.data.end_date ? moment(data.data.end_date) : null,
      });
      setEnBody(data?.data.body_en);
      setIdBody(data?.data.body);
      setImgUrl(data.data.thumbnail);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (location?.state?.id) {
      getDataById(location?.state?.id);
    }
  }, []);

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Tambah/Update Kegiatan</h2>
          <p>Tambah kegiatan dan pengaturan lainnya</p>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Form
              name="basic"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item label="Judul Kegiatan" name="title">
                <Input />
              </Form.Item>

              <Form.Item label="Lokasi Kegiatan" name="location">
                <Input />
              </Form.Item>

              <Form.Item label="Deskripsi Kegiatan" name="description">
                <Input />
              </Form.Item>

              <Form.Item
                label="Tipe Kegiatan"
                name="type"
                rules={[{ required: true, message: "Pilih tipe kegiatan!" }]}
              >
                <Select
                  placeholder="Pilih tipe kegiatan"
                  options={activityTypes}
                  allowClear
                  style={selectStyle}
                />
              </Form.Item>
              {/* 
              <Form.Item label="Tipe Kegiatan" name="type">
                <Input />
              </Form.Item> */}

              <Form.Item
                label="Tanggal & Waktu Mulai"
                required
                style={{ marginBottom: 8 }}
              >
                <Input.Group compact style={{ display: "flex", gap: 8 }}>
                  <Form.Item
                    name="start_date"
                    noStyle
                    rules={[{ required: true, message: "Pilih tanggal!" }]}
                  >
                    <DatePicker
                      format="DD MMM YYYY"
                      locale={locale}
                      placeholder="Tanggal"
                      style={{ flex: 1, maxWidth: 160 }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="start_time"
                    noStyle
                    rules={[{ required: true, message: "Pilih waktu!" }]}
                  >
                    <TimePicker
                      format="HH:mm"
                      locale={locale}
                      placeholder="Waktu"
                      style={{ flex: 1, maxWidth: 120 }}
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>

              <Form.Item
                label="Tanggal & Waktu Selesai"
                required
                style={{ marginBottom: 8 }}
              >
                <Input.Group compact style={{ display: "flex", gap: 8 }}>
                  <Form.Item
                    name="end_date"
                    noStyle
                    rules={[{ required: true, message: "Pilih tanggal!" }]}
                  >
                    <DatePicker
                      format="DD MMM YYYY"
                      locale={locale}
                      placeholder="Tanggal"
                      style={{ flex: 1, maxWidth: 160 }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="end_time"
                    noStyle
                    pakai
                    end_ti
                    rules={[{ required: true, message: "Pilih waktu!" }]}
                  >
                    <TimePicker
                      format="HH:mm"
                      locale={locale}
                      placeholder="Waktu"
                      style={{ flex: 1, maxWidth: 120 }}
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>

              {/* <Form.Item>
                <MyEditor
                  data={idBody}
                  setState={setIdBody}
                  defaultValue="Indonesian Content"
                />
              </Form.Item> */}

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  {isEdit ? "Update Kegiatan" : "Buat Kegiatan"}
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ADD_ACTIVITY;
